import { useEffect, Component, RefObject } from "react";
import ReactDOM from "react-dom";

export default function useOnDocumentClick(
  onClick: () => void,
  excludeRef?: RefObject<Element | Component>
): void {
  useEffect(
    () => {
      const excludeAfterClick = (event: MouseEvent) => {
        // When body is clicked, check that the click event target is not within the provided excludeRef
        if (excludeRef && excludeRef.current) {
          const domNode = ReactDOM.findDOMNode(excludeRef.current);
          if (domNode && !domNode.contains(event.target as Node)) {
            onClick();
          }
        } else {
          onClick();
        }
      };
      document.addEventListener("click", excludeAfterClick);

      // Return a cleanup function
      return () => {
        document.removeEventListener("click", excludeAfterClick);
      };
    },
    // Memoized based on two dependencies
    [onClick, excludeRef]
  );
}
